import request from '@/utils/httpRequest'

export default class DeratedService {
  queryById(id) {
    return request({
      url: '/shye/decorate/wuyeDecorateInfo/queryById',
      method: 'get',
      params: { id: id }
    })
  }

  startFlow(params) {
    return request({
      url: '/decorate/wuyeDecorateInfo/startFlow',
      method: 'post',
      data: params
    })
  }

}
